import React from 'react'
import './style.scss'

const NowPlaying = () => (
    <span className="nowPlaying">NOW PLAYING</span>
)

export default NowPlaying